import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Map } from "immutable";
import { Form, Button } from "antd";
import { UPLOAD_LEDGER_FORM } from "constants/form-fields";
// import { COMPANY_TYPES } from "constants/enums";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import CompanyService from "services/company-service";
import "styles/form.css";
import shortID from "uuid/v4";

const FormItem = Form.Item;

class UploadLedgerForm extends React.Component {

    state = {
        ids: new Map({}),
        removedIds: []
    };

    componentDidMount() {
        this.toggleFormGrid("ADD");
    }

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    submitForm = () => {
        this.props.form.validateFields((err, values) => {
            let details = values.ids && new Map(values.ids).map(_ => {
                let data = new FormData();
                data.append("anchor", _.anchor && _.anchor.id);
                data.append("ledger_file", _.ledger_file);
                data.append("seller", _.seller && _.seller.id);
                return data;
            }).toList().toArray();

            this.props.submitForm(details);

        });
    }

    searchAnchor = (val) => {
        return CompanyService.getCompanyProfiles(null, val, JSON.stringify([1,2])).then(({data}) => {
            return {
                data: data && data.results && data.results.map(_ => ({
                    name: _.name + " | " + _.id,
                    id: _.id
                }))
            };
        });
    };

    searchSeller = (val) => {
        return CompanyService.getCompanyProfiles(null, val, JSON.stringify([1,2])).then(({data}) => {
            return {
                data: data && data.results && data.results.map(_ => ({
                    name: _.name + " | " + _.id,
                    id: _.id
                }))
            };
        });
    };

    toggleFormGrid = (action = "ADD", id) => {
        const { ids } = this.state;
        let removedIds = this.state.removedIds;
        const newID = shortID();
        switch (action) {
        case "ADD":
            this.setState({
                ids: ids.set(newID, newID)
            });
            break;
        case "REMOVE": {
            removedIds.push(id);
            this.setState({
                ids: ids.filter(_ => _ !== id),
                removedIds: removedIds
            });
            break;
        }
        default:
        }
    };

    getFilterOption = (val, option) => {
        let valArr = val.split(" ");
        if(option.props.value.includes(valArr)) {
            return true;
        }
        // return false;
        return true;
    }

    render() {
        return (
            <Form
                className={cx("form", "br-3")}
            >
                {
                    this.state.ids.map(_ => (
                        <div
                            key={`ID-${_}`}
                            className="form-row form-row-compact bg-grey p-10 br-3">

                            {UPLOAD_LEDGER_FORM
                                .map((field, fieldName) => {
                                    if (fieldName === "anchor") {
                                        field.onSearch = this.searchAnchor;
                                        field.filterOption = this.getFilterOption;
                                    }
                                    if (fieldName === "seller") {
                                        field.onSearch = this.searchSeller;
                                        field.filterOption = this.getFilterOption;
                                    }
                                    return this.fieldGenerator(
                                        `ids.${_}|id.${fieldName}`,
                                        field,
                                        this.getErrorOnField(fieldName)
                                    )();
                                })
                                .toList()}
                            <FormItem className={cx("m-0 form-btn")}>
                                <Button
                                    shape="circle"
                                    icon={"minus"}
                                    onClick={this.toggleFormGrid.bind(
                                        null,
                                        "REMOVE",
                                        _
                                    )}
                                />
                            </FormItem>
                        </div>

                    )).toList().toArray()
                }
                <FormItem className={cx("form-btn m-0")}>
                    <Button
                        type="dashed"
                        icon={"plus"}
                        // disabled={this.props.formDisabled}
                        onClick={this.toggleFormGrid.bind(null, "ADD")}>
                        Add New
                    </Button>
                </FormItem>
                <div className="d-flex justify-content-flex-end">
                    <FormItem className={cx("m-0")}>
                        <Button
                            type="primary"
                            onClick={this.submitForm}
                            // htmlType="submit"
                            icon={"plus"}
                        >
                            Add
                        </Button>
                    </FormItem>
                </div>
            </Form>
        );
    }
}

UploadLedgerForm.propTypes = {
    form: PropTypes.object,
    submitForm: PropTypes.func
};

export default Form.create({})(UploadLedgerForm);